import { ProjectApi } from 'api/ProjectApi';
import { apiClient } from 'container/apiClient';
import { projectMapper } from 'container/projectMapper';
import { responseRateMapper } from 'container/responseRateMapper';

export const projectApi = new ProjectApi(apiClient, projectMapper, responseRateMapper);
